import { useEffect } from 'react';
import styles from './error.module.scss';

const ErrorPage = () => {
  useEffect(() => {
    window.location.href = 'https://datahippo.xyz';
  }, []);

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent}>
        <div className={styles.spinner}></div>
      </div>
    </div>
  );
};

export default ErrorPage;
